var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$isMobileDevice)?_c('Headers'):_vm._e(),_c('app-main',{ref:"appMain"}),(!_vm.$isMobileDevice)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }